/**
 * Central config untuk halaman Home (/home) & Bootcamp (/bootcamp).
 *
 * Ganti link placeholder di bawah dengan link asli:
 * - TELEGRAM_GROUP_URL  : link invite Telegram group BandarmoloNY
 * - VALBURY_URL         : link referral buka akun Valbury
 * - SUCOR_URL           : link referral buka akun Sucor Sekuritas
 * - ADMIN_WHATSAPP_URL  : link WA admin untuk tanya-tanya bootcamp
 */

export const HOME_LINKS = {
  telegramGroup: "https://t.me/+1Dxi7XN0DTo5OTg1",
  valburyOpenAccount: "https://regol.kbvalbury.com/#/register/HY04",
  sucorOpenAccount: "https://onboarding.sucorsekuritas.com/CAB-SBY2/online",
  adminWhatsapp: "https://wa.me/6281234567890?text=Halo%20admin%20BandarmoloNY",
} as const;

export interface BootcampTier {
  id: string;
  name: string;
  price: number;
  period: string;
  description: string;
  features: string[];
  popular?: boolean;
  subscriptionPlanId?: string;
}

export const BOOTCAMP_TIERS: BootcampTier[] = [
  {
    id: "bootcamp-reguler",
    name: "Bootcamp Reguler",
    price: 1499000,
    period: "per program",
    description: "Ikut kelas online BandarmoloNY dari nol sampai bisa baca pergerakan bandar.",
    features: [
      "Akses kelas online (live + rekaman)",
      "Materi bandarmologi dasar–menengah",
      "Grup diskusi Telegram peserta",
      "Sertifikat kelulusan",
    ],
  },
  {
    id: "bootcamp-premium",
    name: "Bootcamp Premium",
    price: 2999000,
    period: "per program",
    description: "Paket paling dipilih — kelas intensif + pendampingan langsung dari mentor.",
    features: [
      "Semua benefit Reguler",
      "Live screener alert via Telegram",
      "Bedah saham & review portofolio bareng mentor",
      "Prioritas tanya-jawab 1-on-1",
      "Akses rekaman selamanya",
    ],
    popular: true,
  },
  {
    id: "bootcamp-vip",
    name: "Bootcamp VIP",
    price: 4999000,
    period: "per program",
    description: "Untuk yang mau dikawal full — seat terbatas tiap angkatan.",
    features: [
      "Semua benefit Premium",
      "Mentoring private (slot terbatas)",
      "Trading plan personal",
      "Akses prioritas event offline",
    ],
  },
];

export const BOOTCAMP_CURRICULUM: { title: string; items: string[] }[] = [
  {
    title: "Modul 1 — Fondasi",
    items: ["Mindset trader vs investor", "Kenalan dengan data broker & bandar", "Setup tools BandarmoloNY"],
  },
  {
    title: "Modul 2 — Membaca Bandar",
    items: ["Broker Summary & Transaction", "Akumulasi vs distribusi", "Foreign flow & insider"],
  },
  {
    title: "Modul 3 — Eksekusi",
    items: ["Trade footprints & bid-offer", "Entry, exit & money management", "Studi kasus saham real"],
  },
];

export function formatIDR(n: number): string {
  return `Rp ${n.toLocaleString("id-ID")}`;
}
